import type { SVGProps } from 'react'

// Round user silhouette with a right-pointing arrow indicator at the bottom-
// right corner — used for the "Delegate to" row in MoreActionsDrawer.
// Matches Figma node `1448:38454`.

export default function UserRight(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="m19 16 3 3-3 3" />
      <path d="M14 19h8" />
    </svg>
  )
}
